import { XMarkIcon } from "@heroicons/react/20/solid";
import { ModalConfig, useModalStore } from "@/stores/use-modal-store";

const SECTIONS = [
  {
    title: "Scores per scene",
    body: "We break your video into scenes and calculate an average score for each one. The graph shows the metrics that can be measured scene by scene: Hook, Visual ease and Hold (Attention), Emotion intensity (Emotion) and Brand attribution (Memory).",
  },
  {
    title: "Video-level scores aren’t on the graph",
    body: "Some scores only make sense across the whole video – Payoff, Authenticity and Message memory, plus the overall Attention, Emotion, Memory and Creative Impact scores. You’ll find these in the scores panel on the right.",
  },
  {
    title: "Scene averages",
    body: "Each score is an average across the whole scene. If a scene has both high and low moments, its peaks and dips may be smoothed out in its single score.",
  },
  {
    title: "Choosing what to show",
    body: "Hover over Attention, Emotion or Memory to tick the metrics you want to compare. Lines are connected across scenes so you can spot patterns and underperforming scenes at a glance.",
  },
];

// The video in-depth view is always rendered on a fixed dark background regardless of the app
// theme, so this modal matches that instead of the theme-aware daisyUI modal-box.
export const VIDEO_GRAPH_EXPLAINED_MODAL_CONFIG: ModalConfig = { className: "w-full max-w-[600px]" };

/**
 * VideoGraphExplainedModal component
 *
 * Explains how the scene performance graph's per-scene scores are calculated, which metrics it can
 * plot, and how to choose which ones are shown.
 */
export const VideoGraphExplainedModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-4 -m-6 p-8 rounded-2xl bg-[#1d232a]">
      {/* Header */}
      <div className="flex items-center gap-1">
        <h2 className="flex-1 text-white font-semibold text-lg">About this graph</h2>
        <button type="button" onClick={close} aria-label="Close" className="cursor-pointer">
          <XMarkIcon className="size-5 text-white" />
        </button>
      </div>

      <div className="flex flex-col gap-4">
        {SECTIONS.map((section) => (
          <div key={section.title} className="text-white/70 text-sm">
            <p className="font-bold text-white">{section.title}</p>
            <p>{section.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
